module.exports = "/_next/static/images/441d6d440450682dcb5764e4226ddccc-prepayment_entrypoint.png.webp";